const Rfc = (): JSX.Element => (
  <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5" filter="url(#filter0_b_1001_105757)">
      <circle cx="35.2593" cy="36.2964" r="21.2593" fill="#99F1BD" />
    </g>
    <mask id="mask0_1001_105757" maskUnits="userSpaceOnUse" x="11" y="6" width="49" height="57">
      <path
        d="M59.1109 38.3703C59.1109 51.5433 48.4321 62.2222 35.2591 62.2222C22.0861 62.2222 11.4072 51.5433 11.4072 38.3703C11.4072 25.1973 22.0861 6.48145 35.2591 6.48145C48.4321 6.48145 59.1109 25.1973 59.1109 38.3703Z"
        fill="#00DC5A"
      />
    </mask>
    <g mask="url(#mask0_1001_105757)">
      <path
        opacity="0.7"
        d="M24.6518 35.4769C24.219 29.2022 29.1924 23.874 35.482 23.874C41.7716 23.874 46.745 29.2022 46.3122 35.4769L43.4731 76.644C43.1835 80.844 39.692 84.103 35.482 84.103C31.272 84.103 27.7805 80.844 27.4909 76.644L24.6518 35.4769Z"
        fill="#00DC5A"
      />
      <g opacity="0.8" filter="url(#filter1_b_1001_105757)">
        <ellipse cx="35.0672" cy="16.8128" rx="9.55356" ry="9.55356" fill="#00DC5A" />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_b_1001_105757"
        x="10"
        y="11.0371"
        width="50.5186"
        height="50.5186"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1001_105757" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1001_105757"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_1001_105757"
        x="19.1051"
        y="0.850675"
        width="31.9246"
        height="31.9241"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="3.2043" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_1001_105757" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1001_105757"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Rfc;
